var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notify"},[(_vm.show)?[_c('BAlert',{attrs:{"variant":_vm.notify,"show":""}},[_vm._v(_vm._s(_vm.notifyMsg))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }